export default function PageTransition({ children }) {
  return (
    <div style={{
      animation: 'pageEnter 300ms cubic-bezier(0.4,0,0.2,1) forwards',
      opacity: 0,
    }}>
      {children}
    </div>
  )
}
